import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  Stack,
  Alert,
  CircularProgress,
} from "@mui/material";
import { patch } from "src/utils/networkUtils";
import { ROLES } from "./adminRoles";

export default function EditAdminDialog({ open, admin, onClose, onSuccess }) {
  const [form, setForm] = useState({ name: "", role: "read_only" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (admin) setForm({ name: admin.name ?? "", role: admin.role });
  }, [admin]);

  const handleClose = () => {
    setError(null);
    onClose();
  };

  const handleSubmit = () => {
    setLoading(true);
    setError(null);
    // The backend rejects an empty name, so only send it when there is one.
    const name = form.name.trim();
    patch(`/admin/users/${admin.id}`, { role: form.role, ...(name && { name }) })
      .then(() => {
        handleClose();
        onSuccess();
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ?? "Failed to update admin user."
        );
      })
      .finally(() => setLoading(false));
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Edit Admin User</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          {error && <Alert severity="error">{error}</Alert>}
          <TextField
            label="Name"
            value={form.name}
            onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
            fullWidth
          />
          <FormControl fullWidth>
            <InputLabel>Role</InputLabel>
            <Select
              label="Role"
              value={form.role}
              onChange={(e) => setForm((f) => ({ ...f, role: e.target.value }))}
            >
              {ROLES.map((r) => (
                <MenuItem key={r.value} value={r.value}>
                  {r.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit} disabled={loading}>
          {loading ? <CircularProgress size={18} /> : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
